// Пороги Engine A — Quote Selection (spec §11). Все в одном месте.
//
// [T] = provisional, калибруется на QA-матрице + live (см. спека §11).

// B3 char-count gate УБРАН (D&R s277.d1): floor=0, любое непустое поле —
// кандидат. Качественный отсев — рубрика осмысленности (§3), не длина: короткие
// плотные фразы («never», «done», «hate it») валидны. См. input.js `preEligible`.

/** §VI stack (A2) max длина отображения, Rule #8 (§7). Слот рендера CAP_STACK=180. */
export const STACK_MAX = 180;

/** §VI quote_n (A3) max длина отображения, Rule #8 (§7). Слот рендера CAP_QN=250. */
export const QUOTE_N_MAX = 250;

/** Порядок полей для вывода/итерации. T4 «who was around» снят — s443.d1 / s452.d1. */
export const FIELDS = ['T1', 'T2', 'T3'];

/**
 * Register-fit порядок (spec §1.1, G7-2 п.3): T3 несёт carrier-логику.
 * Используется в dominance-тае и fallback-цепи (§6). T4 снят — s443.d1 / s452.d1.
 */
export const REGISTER = ['T3', 'T2', 'T1'];
